<template>
  <div class="product-detail-component">
    <div class="product-detail px-3 pt-5" v-if="product !== undefined">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="yellow-text">{{ product.name }}</h2>
          </div>
        </div>
        <div class="row mt-3 d-none d-lg-block">
          <div class="col-lg-6">
            <div class="underlined">sizes</div>
            <div class="specs yellow-text size">{{ product.sizes }}</div>
          </div>
          <div class="col-lg-6">
            <div class="underlined">price starts at</div>
            <div class="specs yellow-text price">Php {{ product.price }}</div>
          </div>
        </div>
        <div class="row mt-5 text-center">
          <div class="col-6">
            <a
              :href="product.lazada_url"
              target="_blank"
              class="btn btn-sm btn-dutche-orange lazada"
            >
              <strong>Shop from lazada</strong>
            </a>
          </div>
          <div class="col-6">
            <a
              :href="product.shopee_url"
              target="_blank"
              class="btn btn-sm btn-dutche-orange shopee"
            >
              <strong>Shop from shopee</strong>
            </a>
          </div>
        </div>
        <div class="row mt-5 d-none d-lg-block">
          <div class="col-12">
            <div class="underlined">description</div>
            <div class="description yellow-text mt-2">
              {{ product.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductDetail",
  props: {
    productDetails: Object,
  },
  data() {
    return {
      product: undefined,
    }
  },
  watch: {
    productDetails() {
      this.product = this.productDetails;
    },
  },
};
</script>

<style lang="sass" scoped>
.product-detail
  overflow: hidden
  width: 100%
  min-height: 553px
  height: auto
  background-color: $dutche-primary-violet

  h2
    font-family: "Might Could"
    font-size: 3rem

.yellow-text
  color: $dutche-primary-yellow

.underlined
  text-transform: uppercase
  color: $white
  border-bottom: 1px solid $dutche-primary-brown
  font-size: small
  font-weight: bold

.specs
  font-size: 1em

.btn-dutche-orange
  text-transform: uppercase
  border-radius: 15px
  background-color: $dutche-primary-orange
  color: $white

.description
  overflow-y: scroll
  max-height: 120px
</style>
